import { IMenu } from "@core/models/interfaces";

export const LIST_MENU: IMenu[] = [
    {
        "id": 1,
        "code": "caremoni_organization_management",
        "name": "事業所管理"
    },
    {   
        "id": 2,
        "code": 'caremoni_app_tv_content_category',
        "name": 'コンテンツ区分一覧'
    },
    {
        "id": 3, 
        "code": 'caremoni_app_tv_content_list', 
        "name": 'コンテンツ一覧' },
    {
        "id": 4,
        "code": "caremoni_device_management",
        "name": "デバイス管理"
    }
];
